var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 297,
    viewBox: "0 0 297 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.236 0C66.367 0 0 66.367 0 148.236C0 230.105 66.367 296.472 148.236 296.472C230.103 296.472 296.47 230.105 296.47 148.236C296.47 66.367 230.104 0 148.236 0ZM241.74 241.742C216.763 266.718 183.557 280.472 148.236 280.472C112.914 280.472 79.707 266.717 54.73 241.742C29.754 216.765 16 183.558 16 148.236C16 112.914 29.755 79.707 54.73 54.73C79.707 29.755 112.914 16 148.236 16C183.557 16 216.763 29.755 241.74 54.73C266.716 79.707 280.471 112.915 280.471 148.236C280.471 183.557 266.716 216.766 241.74 241.742Z",
    fill: "url(#paint0_radial_1927_48132)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6383 133.236H62.9023V164.236H69.6383C72.8883 164.236 75.3643 163.007 77.2073 160.816C79.0493 158.625 79.9023 155.628 79.9023 152.092V144.555C79.9023 141.061 79.0493 138.466 77.2073 136.275C75.3643 134.084 72.8883 133.236 69.6383 133.236Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.077 133.236H218.902V146.236H226.922C229.468 146.236 231.366 145.531 232.619 144.455C233.871 143.379 234.497 141.826 234.497 139.715C234.497 137.646 233.871 136.041 232.619 134.82C231.366 133.598 229.519 133.236 227.077 133.236Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.238 32.834C84.5029 32.834 32.8359 84.501 32.8359 148.236C32.8359 211.971 84.5029 263.638 148.238 263.638C211.972 263.638 263.638 211.971 263.638 148.236C263.638 84.501 211.973 32.834 148.238 32.834ZM236.766 171.236C235.938 170.236 235.463 169.327 235.215 167.774C234.967 166.222 234.905 164.613 234.905 163.226V160.028C234.905 157.773 234.226 156.193 232.995 154.941C231.764 153.689 229.967 153.236 227.732 153.236H218.905V171.236H210.837H210.036H181.026H179.883H153.978H151.842H144.819L141.746 161.236H125.881L122.808 171.236H118.3H113.649H86.9039V160.647C85.9039 162.51 85.0709 164.34 83.5459 165.834C79.9649 169.343 75.6319 171.236 70.1059 171.236H53.9039V126.236H70.1059C75.6319 126.236 79.9649 127.759 83.5459 131.288C85.0699 132.791 85.9039 134.244 86.9039 136.109V126.236H117.904V133.236H95.9039V144.236H114.904V151.236H95.9039V164.236H116.051L129.202 126.236H138.485L151.903 164.724V126.236H160.903V164.236H179.903V126.236H210.034H210.772H227.078C232.231 126.236 236.275 127.17 239.183 129.518C242.09 131.868 243.557 134.902 243.557 139.103C243.557 141.442 242.97 143.45 241.749 145.126C240.527 146.802 238.787 148.158 236.428 149.192C239.098 149.979 240.949 151.294 242.119 153.135C243.287 154.977 243.903 157.254 243.903 159.965V163.287C243.903 164.55 243.941 165.869 244.283 167.245C244.625 168.622 244.903 169.641 245.903 170.303V171.235L236.766 171.236Z",
    fill: "url(#paint1_radial_1927_48132)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M188.902 144.236H206.902V151.236H188.902V164.236H209.902V133.236H188.902V144.236Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.733 136.236L128.113 154.236H139.508L133.919 136.236H133.733Z",
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1927_48132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.235 148.236) rotate(90) scale(148.236 148.235)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1927_48132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148 148) rotate(89.8826) scale(115.638 115.637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFAF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerIcon);
export default __webpack_public_path__ + "static/media/dealer-icon.16836ed1bc06fc14c43b06fa3af5f8f2.svg";
export { ForwardRef as ReactComponent };